// extracted by mini-css-extract-plugin
export default {"timestampContainer":"appTimestamps_timestampContainer__0jAE3","createdUpdatedLeft":"appTimestamps_createdUpdatedLeft__-30WD","time":"appTimestamps_time__h9dZM"};